import { Airport, FlightData, InitProps } from '../types'
import '@fortawesome/fontawesome-free/css/brands.css'
import '@fortawesome/fontawesome-free/css/solid.css'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import { getStatusLabel } from './utils'
import { t } from 'i18next'

export const redirectOagUrl = 'https%3A%2F%2Fwww.oag.com'

function summaryFlight (flight: FlightData, displayName: string) {
  if (displayName) {
    return t('TRACKER.SOCIAL_PART.CUSTOM_MESSAGE', {
      airlineName: flight.flightId.airlineName,
      airlineCode: flight.flightId.airlineCode,
      flightNumber: flight.flightId.flightNumber,
      displayName
    })
  } else {
    return '\n' +
      `${flight.flightId.airlineName} (${flight.flightId.airlineCode}) ${flight.flightId.flightNumber}\n` +
      `${t('TRACKER.SOCIAL_PART.STATUS')}: ${getStatusLabel(flight, false)}\n` +
      '\n' + summaryAirport(flight.departureAirport, t('TRACKER.SOCIAL_PART.DEPARTURE')) +
      '\n' + summaryAirport(flight.arrivalAirport, t('TRACKER.SOCIAL_PART.ARRIVAL'))
  }
}

function summaryAirport (airport: Airport, label: string) {
  return `${label}: ${airport.name} (${airport.code})\n` +
    `${t('TRACKER.SOCIAL_PART.TIME')}: ${airport.time.toLocaleString()}\n` +
    (airport.terminal ? `${t('TRACKER.FLIGHT_PART.TABLE_TERMINAL')}: ${airport.terminal}\n` : '') +
    (airport.gate ? `${t('TRACKER.FLIGHT_PART.TABLE_GATE')}: ${airport.gate}\n` : '')
}

function onShareFacebook (flight: FlightData, displayName: string, redirectUrl: string, id: string): string {
  const info = summaryFlight(flight, displayName)
  let url = 'https://www.facebook.com/sharer.php?'
  url += id ? `app_id=${id}&u=${redirectUrl}` : 'u=' + redirectOagUrl
  url += '&quote=' + encodeURIComponent(info)
  return url
}

function onShareWhatsApp (flight: FlightData, displayName: string, linkUrl: string): string {
  const info = summaryFlight(flight, displayName)
  return 'https://api.whatsapp.com/send?&text=' + encodeURIComponent(info) + ' ' + linkUrl
}

function onShareMail (flight: FlightData, displayName: string, linkUrl: string): string {
  const acode = flight.flightId.airlineCode
  const fnum = flight.flightId.flightNumber
  const info = summaryFlight(flight, displayName)
  return `mailto:?subject=${encodeURIComponent(acode)} ${encodeURIComponent(fnum)}&body=${encodeURIComponent(info)} ${linkUrl}`
}

function onShareTwitter (flight: FlightData, displayName: string, linkUrl: string): string {
  const info = summaryFlight(flight, displayName)
  return `https://twitter.com/intent/tweet?url=${(linkUrl || redirectOagUrl)}&text=` + encodeURIComponent(info)
}

export class FlightViewMapLibTrackerSocialSharing {
  parentId: string = ''
  displayName: string = ''
  linkUrl: string = ''
  facebookAppRedirectUrl: string = ''
  facebookAppId: string = ''

  constructor (parentId: string, props: InitProps) {
    this.parentId = parentId
    this.displayName = props.displayName || ''
    this.linkUrl = props.linkUrl || ''
    this.facebookAppRedirectUrl = props.facebookAppRedirectUrl || ''
    this.facebookAppId = props.facebookAppId || ''
  }

  public updateUI (flight: FlightData) {
    const oldContainer = document.getElementById('social-buttons')
    oldContainer?.parentElement?.removeChild(oldContainer)

    const container = document.createElement('div')
    container.id = 'social-buttons'

    const facebookButton = document.createElement('a')
    facebookButton.id = 'fblogo'
    const facebookLogo = document.createElement('i')
    facebookLogo.className = 'fa-brands fa-facebook'
    facebookButton.appendChild(facebookLogo)
    facebookButton.target = '_blank'
    facebookButton.title = t('TRACKER.SOCIAL_PART.FACEBOOK_BUTTON')
    facebookButton.href = onShareFacebook(flight, this.displayName, this.facebookAppRedirectUrl, this.facebookAppId)

    const whatsappButton = document.createElement('a')
    whatsappButton.id = 'wplogo'
    const whatsappLogo = document.createElement('i')
    whatsappLogo.className = 'fa-brands fa-whatsapp'
    whatsappButton.appendChild(whatsappLogo)
    whatsappButton.target = '_blank'
    whatsappButton.title = t('TRACKER.SOCIAL_PART.WHATSAPP_BUTTON')
    whatsappButton.href = onShareWhatsApp(flight, this.displayName, this.linkUrl)

    const emailButton = document.createElement('a')
    emailButton.id = 'wplogo'
    const emailLogo = document.createElement('i')
    emailLogo.className = 'fa-solid fa-envelope'
    emailButton.appendChild(emailLogo)
    emailButton.target = '_blank'
    emailButton.title = t('TRACKER.SOCIAL_PART.EMAIL_BUTTON')
    emailButton.href = onShareMail(flight, this.displayName, this.linkUrl)

    const twitterButton = document.createElement('a')
    twitterButton.id = 'twlogo'
    const twitterLogo = document.createElement('i')
    twitterLogo.className = 'fa-brands fa-x-twitter'
    twitterButton.appendChild(twitterLogo)
    twitterButton.target = '_blank'
    twitterButton.title = t('TRACKER.SOCIAL_PART.TWITTER_BUTTON')
    twitterButton.href = onShareTwitter(flight, this.displayName, this.linkUrl)

    container.appendChild(facebookButton)
    container.appendChild(whatsappButton)
    container.appendChild(emailButton)
    container.appendChild(twitterButton)

    const socialContainer = document.getElementById(this.parentId)
    socialContainer.prepend(container)
  }
}
